import React, { FC, useEffect, useState } from 'react'
import {
  DsDialog,
  DsRemixIcon,
  DsStack,
  DsTypography
} from '@am92/react-design-system'

import withPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import OFFLINE_OVERLAY_PAGE_CONSTANTS from './OfflineOverlay.PageConstants'
import { T_OFFLINE_OVERLAY_PAGE_CONSTANTS } from './OfflineOverlay.PageConstants/TYPES'

const OfflineOverlay: FC<
  IWithPageConstantsProps<T_OFFLINE_OVERLAY_PAGE_CONSTANTS>
> = ({ PAGE_CONSTANTS }) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)
  const [dialogOpen, setDialogOpen] = useState<boolean>(!navigator.onLine)

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  useEffect(() => {
    const goOnline = () => {
      setDialogOpen(false)
      setIsOnline(true)
    }
    const goOffline = () => {
      setDialogOpen(true)
      setIsOnline(false)
    }

    // TODO: Check correct listeners for cordova app
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)

    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  if (isOnline) return null

  return (
    <DsDialog
      open={dialogOpen}
      onClose={handleDialogClose}
      ContentProps={{
        sx: { marginTop: 'var(--ds-spacing-zero)' }
      }}
    >
      <DsStack direction='column' spacing='var(--ds-spacing-glacial)'>
        <DsRemixIcon
          color='error'
          className='ri-signal-wifi-error-line'
          fontSize='tropical'
        />
        <DsTypography
          component='div'
          variant='headingBoldSmall'
          textAlign='center'
        >
          {PAGE_CONSTANTS.OFFLINE_TITLE}
        </DsTypography>
        <DsTypography
          component='div'
          variant='bodyRegularLarge'
          textAlign='center'
        >
          {PAGE_CONSTANTS.OFFLINE_DESCRIPTION}
        </DsTypography>
      </DsStack>
    </DsDialog>
  )
}

export default withPageConstants(OFFLINE_OVERLAY_PAGE_CONSTANTS, OfflineOverlay)
